import React from 'react';
import ProjectsList from './components/ProjectsList/ProjectsList';

type Props = {
    rootElement: HTMLElement
}

const App: React.FC<Props> = ({rootElement}) => {
    const context = rootElement.dataset.context ? rootElement.dataset.context : 'development'

    return (
        <div className="techniconcept-projects-app">
            <ProjectsList context={context} rootElement={rootElement}/>
        </div>
    );

}

export default App
